import React from 'react';
import { useDispatch } from 'react-redux';
import { Monitor } from 'react-feather';
import { translate } from '../../../shared/translations';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { H6, Paragraph1, Subhead2 } from '../../../shared/theme/styles';
import { setActiveDialogAction } from '../../../actions/actionCreators';

const QuestionsModalContent = () => (
    <div id="questionsModalContent">
        <div className="questionsModalTextBlock">
            <div className="text-primary" style={H6}>
                {translate('reps')}
            </div>
            <div className="text-secondary" style={Paragraph1}>
                {translate('reps_login_question_information')}
            </div>
        </div>
        <div className="questionsModalTextBlock">
            <div className="text-primary" style={H6}>
                {translate('managers')}
            </div>
            <div className="text-secondary" style={Paragraph1}>
                {translate('managers_login_question_information')}
            </div>
        </div>
        <div className="text-secondary questionsModalFooter" style={Subhead2}>
            {translate('contact_manager_sentence')}
        </div>
    </div>
);

export const LoginQuestionsModal = ({ show }) => {
    const dispatch = useDispatch();
    const onDialogClose = () => {
        dispatch(setActiveDialogAction(''));
    };

    const footerButtons = [
        {
            text: translate('ok'),
            variant: 'primary',
            rightFloat: true,
            onButtonClick: onDialogClose,
        },
    ];
    return (
        <Dialog
            type="action"
            footerButtons={footerButtons}
            size="ml"
            centered
            icon={<Monitor className="modalDialogIcon" size={16} />}
            title={translate('which_login_should_i_use')}
            show={show}
            action={{
                content: (<QuestionsModalContent />),
            }}
            onHide={onDialogClose}
            indentBody
        />
    );
};

export default LoginQuestionsModal;
